import type { RunRecord } from '@orgsim/shared';
import { api } from './client';

// The server adds who owns the run and when it last stored it.
export type RemoteRun = RunRecord & { userId: string; updatedAt: number };

// What the run list carries per run: no scenario snapshot and no event log.
export type RunSummary = {
  id: string;
  scenarioId: string;
  scenarioName: string;
  startedAt: number;
  finishedAt?: number;
  userId: string;
  updatedAt: number;
  eventCount: number;
};

const path = (id: string) => `/api/runs/${encodeURIComponent(id)}`;

export const listRuns = () => api.get<RunSummary[]>('/api/runs');
export const getRun = (id: string) => api.get<RemoteRun>(path(id));
export const putRun = (record: RunRecord) =>
  api.put<{ id: string; updatedAt: number }>(path(record.id), record);
export const deleteRun = (id: string) => api.del<void>(path(id));
